import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PATH } from '@app/constants';
import { PipesModule } from '@app/pipes';
import { CountUpModule } from 'ngx-countup';

@Component({
  selector: 'mnf-dashboard-v2-quick-actions',
  standalone: true,
  imports: [RouterModule, PipesModule, CountUpModule],
  templateUrl: './dashboard-v2-quick-actions.component.html',
  styleUrl: './dashboard-v2-quick-actions.component.scss'
})
export class DashboardV2QuickActionsComponent implements OnChanges {
  path = PATH;
  devs: number  = 0;
  numberProjects: string = '-';
  
  @Input() developmentsAvailable = [];

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes['developmentsAvailable']) {
      this.developmentsAvailable = changes['developmentsAvailable'].currentValue;
      this.numberProjects = this.developmentsAvailable?.length?.toString();
    }

  }
}